<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Journal</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Journal</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="journal.id === null">New</span>
                  <span v-else>
                    {{ journal.journal_code }}
                  </span>
                </li>
              </ol>
              <button type="button" @click="updateJournal('posted')" class="btn btn-soft-primary pull-left" v-if="journal.id !== null">Post</button>
              <button type="button" @click="updateJournal('draft')" class="btn btn-soft-primary pull-left" v-if="journal.id !== null">Save Draft</button>
              <button type="button" @click="saveJournal('posted')" class="btn btn-soft-primary pull-left" v-if="journal.id === null">Post</button>
              <button type="button" @click="saveJournal('draft')" class="btn btn-soft-primary pull-left" v-if="journal.id === null">Save Draft</button>
              <button type="button" @click="updateJournal('posted')" class="btn btn-soft-primary pull-left" v-if="journal.id !== null">Post</button>
              <button type="button" @click="validate" class="btn btn-soft-primary pull-left">Validate</button>
            </div>
          </div>
          <div class="card card-list">
            <div class="card-header">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <span v-if="journal.id === null">New</span>
                  <span v-else>{{ journal.journal_code }}</span>
                </h5>
              </div>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                  <div class="col-md-6">
                    <div class="form-group row">
                        <label for="journal_date" class="col-sm-4 col-form-label">Date <span class="text-danger">*</span></label>
                        <div class="col-sm-8">
                            <datetime v-model="journal.journal_date" format="dd/MM/yyyy" class="form-control" id="journal_date"></datetime>
                            <div class="invalid-feedback">
                              Error
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="contact" class="col-sm-4 col-form-label">Contact</label>
                        <div class="col-sm-8">
                            <v-select :options="contactSelect" :reduce="contact => contact.meta.code" label="contact" v-model="journal.contact" class="vsc-custom"/>
                        </div>
                    </div>
                    <div class="form-group row">
                      <label for="type_id" class="col-sm-4 col-form-label">Type <span class="text-danger">*</span></label>
                      <div class="col-sm-8">
                          <select v-model="journal.type_id" class="form-control">
                              <option v-for="i in typeList" :key="i.id" v-bind:value="i.id">{{ i.name }}</option>
                          </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="type_id" class="col-sm-4 col-form-label">Company</label>
                      <div class="col-sm-8">
                        <select v-model="journal.company_no" class="form-control">
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group row">
                          <label for="ref_no" class="col-sm-4 col-form-label">#Ref</label>
                          <div class="col-sm-8">
                            <b>{{ journal.ref_no }}</b>
                          </div>
                      </div>
                      <div class="form-group row">
                          <label for="journal_description" class="col-sm-4 col-form-label">Description</label>
                          <div class="col-sm-8">
                            <p>{{ journal.journal_description }}</p>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="button" class="btn btn-sm btn-outline-danger pull-right" data-toggle="modal" data-target="#modalTemplateList" data-backdrop="static" data-keyboard="false"><i class="fa fa-book" aria-hidden="true"></i> Template</button>
                </div>
              </div>
              <div class="row mt-1">
                  <div class="table-responsive">
                      <table class="table table-sm table-item table-striped table-hover">
                          <thead>
                              <tr>
                                  <th style="width: 20%">Account Code</th>
                                  <th style="width: 20%">Remark</th>
                                  <th style="width: 20%; text-align: right">Debit</th>
                                  <th style="width: 20%; text-align: right">Credit</th>
                                  <th style="width: 5%"></th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(d, index) in detailList" :key="d.id">
                                  <td>
                                    <v-select :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="d.account_code" @keyup.enter="d.edit=false" @change="selectedAccount(index)" @input="selectedAccount(index)" :disabled="disabled"/>
                                  </td>
                                  <td><b>{{ d.remark }}</b></td>
                                  <td class="text-right">
                                    {{ d.debit | currency }}
                                  </td>
                                  <td class="text-right">
                                    {{ d.credit | currency }}
                                  </td>
                                  <td>
                                    <button class="btn btn-primary btn-table-sm" @click="removeItem(index)">
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                  </td>
                              </tr>
                              <tr>
                                  <td colspan="5">
                                      <span @click="addLine" style="color:blue; cursor: pointer">
                                          Add Line
                                      </span>
                                  </td>
                              </tr>
                          </tbody>
                          <tfoot>
                              <tr style="background-color: #ccc;font-weight: bold">
                                  <td></td>
                                  <td style="text-align: right">Total:</td>
                                  <td style="text-align: right">{{ totalDebet | currency }}</td>
                                  <td style="text-align: right">{{ totalCredit | currency }}</td>
                                  <td></td>
                              </tr>
                          </tfoot>
                      </table>
                  </div>
              </div>
            </div>

            <div class="card-footer">
              <button type="button" @click="updateJournal('posted')" class="btn btn-primary pull-right" v-if="journal.id !== null">Post</button>
              <button type="button" @click="updateJournal('draft')" class="btn btn-warning pull-right" v-if="journal.id !== null">Save Draft</button>
              <button type="button" @click="saveJournal('posted')" class="btn btn-primary pull-right" v-if="journal.id === null">Post</button>
              <button type="button" @click="saveJournal('draft')" class="btn btn-warning pull-right" v-if="journal.id === null">Save Draft</button>
            </div>
        </div>
        </div>
      </div>
      <JournalTemplateModal @addTemplate="addTemplate" />
      <!-- <pre>{{ journal }}</pre> -->
  </div>
</template>
<script>
import axios from 'axios'
import { journalUrl, getHeader } from '@/config'
import { mapState } from 'vuex'
import JournalTemplateModal from '@/components/journal/JournalTemplateModal.vue'

export default {
  name: 'JournalSystemForm',
  props: ['journal'],
  components: {
    JournalTemplateModal
  },
  data () {
    return {
      alert: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    async validate () {
      this.alert = []
      if (this.totalDebet !== this.totalCredit) {
        this.alert.push('<b>Total Journal</b> tidak balance')
      }
    },
    async addTemplate (id) {
      await axios.get(journalUrl + '/template/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.journal.details = []
          var array = response.data.data.details
          for (let i = 0; i < array.length; i++) {
            var obj = {}
            if (array[i].method === 'debit') {
              obj = {
                journal_code: null,
                account_code: array[i].account_code,
                account_name: array[i].account_name,
                remark: array[i].remark,
                debit: '1',
                credit: '0',
                edit: true
              }
            } else {
              obj = {
                journal_code: null,
                account_code: array[i].account_code,
                account_name: array[i].account_name,
                remark: array[i].remark,
                debit: '0',
                credit: '1',
                edit: true
              }
            }
            this.journal.details.push(obj)
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    setCredit: function (index) {
      var no = 0
      if (this.journal.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var details = this.journal.details[no]
      if (details.debit.length > 0) {
        details.debit = '0'
      }
    },
    setDebet: function (index) {
      var no = 0
      if (this.journal.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var details = this.journal.details[no]
      if (details.credit.length > 0) {
        details.credit = '0'
      }
    },
    selectedAccount: function (index) {
      var no = 0
      if (this.journal.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var accCode = this.journal.details[no].account_code
      var accList = this.accountList.find(d => d.account_code === accCode)
      this.journal.details[no].account_name = accList.account_name
    },
    addLine: function () {
      var obj = {
        journal_code: null,
        account_code: null,
        account_name: null,
        remark: null,
        debit: '0',
        credit: '0',
        edit: true
      }
      this.journal.details.push(obj)
    },
    editItem: function (index) {
      var no = 0
      if (this.journal.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      for (let i = 0; i < this.journal.details.length; i++) {
        if (this.journal.details[i]) {
          this.journal.details[i].edit = false
        }
      }
      this.journal.details[no].edit = true
    },
    removeItem: function (index) {
      var no = 0
      if (this.journal.details.length > 1) {
        if (this.journal.details[0].id === null) {
          no = index + 1
        } else {
          no = index
        }
        this.journal.details.splice(no, 1)
      }
    },
    backParent: function () {
      this.alert = []
      this.$emit('backClicked')
    },
    async updateJournal (status) {
      await this.validate()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.journal.status = status
      var array = this.journal.details
      var details = []
      var totalDebet = 0
      var totalCredit = 0
      for (let i = 0; i < array.length; i++) {
        var debit = array[i].debit.replace(/\./g, '')
        var credit = array[i].credit.replace(/\./g, '')
        totalDebet += parseFloat(debit)
        totalCredit += parseFloat(credit)
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            journal_code: this.journal.journal_code,
            account_code: array[i].account_code,
            remark: array[i].remark,
            debit: array[i].debit.replace(/\./g, ''),
            credit: array[i].credit.replace(/\./g, ''),
            branch_no: this.journal.branch_no,
            journal_date: this.journal.journal_date,
            contact: this.journal.contact,
            company_no: this.journal.company_no
          }
          details.push(obj)
        } else {
          obj = {
            id: array[i].id,
            journal_code: this.journal.journal_code,
            account_code: array[i].account_code,
            remark: array[i].remark,
            debit: array[i].debit.replace(/\./g, ''),
            credit: array[i].credit.replace(/\./g, ''),
            branch_no: this.journal.branch_no,
            journal_date: this.journal.journal_date,
            contact: this.journal.contact,
            company_no: this.journal.company_no
          }
          details.push(obj)
        }
      }
      var data = {
        id: this.journal.id,
        journal_code: this.journal.journal_code,
        journal_date: this.journal.journal_date,
        ref_no: this.journal.ref_no,
        contact: this.journal.contact,
        journal_description: this.journal.journal_description,
        type_id: this.journal.type_id,
        status: status,
        debit: totalDebet,
        credit: totalCredit,
        branch_no: this.journal.branch_no,
        ledger_id: this.journal.ledger_id,
        book_no: this.journal.book_no,
        lock: this.journal.lock,
        org_id: this.journal.org_id,
        company_no: this.journal.company_no,
        details: details
      }
      console.log(data)
      axios.put(journalUrl + '/' + this.journal.id, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.alert = []
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async saveJournal (status) {
      await this.validate()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.journal.status = status
      var array = this.journal.details
      var details = []
      var totalDebet = 0
      var totalCredit = 0
      for (let i = 0; i < array.length; i++) {
        var debit = array[i].debit.replace(/\./g, '')
        var credit = array[i].credit.replace(/\./g, '')
        totalDebet += parseFloat(debit)
        totalCredit += parseFloat(credit)
        var obj = {
          journal_code: this.journal.journal_code,
          account_code: array[i].account_code,
          remark: array[i].remark,
          debit: debit,
          credit: credit,
          branch_no: this.journal.branch_no,
          journal_date: this.journal.journal_date,
          contact: this.journal.contact,
          company_no: this.journal.company_no
        }
        details.push(obj)
      }
      var data = {
        id: null,
        journal_code: null,
        journal_date: this.journal.journal_date,
        ref_no: this.journal.ref_no,
        contact: this.journal.contact,
        journal_description: this.journal.journal_description,
        type_id: this.journal.type_id,
        status: status,
        debit: totalDebet,
        credit: totalCredit,
        branch_no: this.journal.branch_no,
        ledger_id: this.journal.ledger_id,
        book_no: this.journal.book_no,
        lock: this.journal.lock,
        org_id: this.journal.org_id,
        company_no: this.journal.company_no,
        details: details
      }
      console.log(data)
      axios.post(journalUrl, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response)
          this.alert = []
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  },
  computed: {
    ...mapState({
      typeList: state => state.journals.journalTypes,
      contactList: state => state.journals.journalContacts,
      accountList: state => state.accounts.accountList,
      branchList: state => state.branches.branchList,
      companyList: state => state.companies.companyList
    }),
    totalDebet: function () {
      var array = this.journal.details
      var total = 0
      for (let i = 0; i < array.length; i++) {
        var debit = parseFloat(array[i].debit)
        total += debit
      }
      return total
    },
    totalCredit: function () {
      var array = this.journal.details
      var total = 0
      for (let i = 0; i < array.length; i++) {
        var credit = parseFloat(array[i].credit)
        total += credit
      }
      return total
    },
    accountSelect: function () {
      var loop = []
      for (let i = 0; i < this.accountList.length; i++) {
        var obj = {
          account: this.accountList[i].account_code + ' - ' + this.accountList[i].account_name,
          meta: {
            code: this.accountList[i].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    },
    contactSelect: function () {
      var loop = []
      for (let i = 0; i < this.contactList.length; i++) {
        var obj = {
          contact: this.contactList[i].contact_no + ' - ' + this.contactList[i].contact_name,
          meta: {
            code: this.contactList[i].contact_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    detailList () {
      return this.journal.details.filter(d => d.id !== null)
    }
  }
}
</script>
